import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-28d49b72"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["href"]

import { computed } from 'vue'

    
export default /*#__PURE__*/_defineComponent({
  name: 'SvgIcon',
  props: {
        iconClass: {
            type: String,
            default: '',
        },
        className: {
            type: String,
            default: '',
        },
    },
  setup(__props) {

const props = __props

    
    const iconName = computed(() => `#icon-${props.iconClass}`)
    const svgClass = computed(() => {
        if (props.className) {
            return 'svg-icon ' + props.className
        } else {
            return 'svg-icon'
        }
    })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    class: _normalizeClass(_unref(svgClass)),
    "aria-hidden": "true"
  }, [
    _createElementVNode("use", { href: _unref(iconName) }, null, 8, _hoisted_1)
  ], 2))
}
}

})